const moderation = [
	{
		path: '/community/moderation',
		name: 'community-moderation',
		component: () => import('@/views/community/moderation/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,moderation',
		},
	},
]

export default moderation
